import { render, staticRenderFns } from "./walletRecord.vue?vue&type=template&id=0cf94246&scoped=true&"
import script from "./walletRecord.vue?vue&type=script&lang=js&"
export * from "./walletRecord.vue?vue&type=script&lang=js&"
import style0 from "./walletRecord.vue?vue&type=style&index=0&id=0cf94246&prod&scoped=true&lang=css&"
import style1 from "./walletRecord.vue?vue&type=style&index=1&id=0cf94246&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf94246",
  null
  
)

export default component.exports